module.exports = __webpack_public_path__ + "img/upscreen_4.c20dcd63.jpg";